// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"106":"3b9176cd","473":"565f37c7","771":"4f60cff8","941":"41c2ee96"}[chunkId] + ".css";
};